import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBBVBGs8RmtL7l8VwecJxDpw2EgBuztBBo",
  authDomain: "probitrading.firebaseapp.com",
  databaseURL: "https://probitrading-default-rtdb.firebaseio.com/",
  projectId: "probitrading",
  storageBucket: "probitrading.firebasestorage.app",
  messagingSenderId: "928488667090",
  appId: "1:928488667090:web:9d3f307bdd32f13c6cba0b",
  measurementId: "G-45HPKVNFFW",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);

export { auth, database };
